import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PROFILE } from "@/data/content";
import { useLanguage } from "@/context/LanguageContext";

const LINK_DEFS = [
  { slug: "linkedin", href: PROFILE.linkedin },
  { slug: "email", href: `mailto:${PROFILE.email}` },
  { slug: "download-cv", href: PROFILE.cvUrl },
];

export default function Contact() {
  const { t } = useLanguage();
  const c = t.contact;
  const LINKS = LINK_DEFS.map((l, i) => ({ ...l, label: c.links[i].label }));

  return (
    <footer id="contact" className="bg-ink text-paper py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-aurora mb-8">{c.label}</p>
          <h2 className="font-display font-extrabold tracking-tighter text-5xl md:text-7xl lg:text-8xl leading-[0.9]">
            {c.titlePrefix}<span className="font-serif-accent italic font-medium text-aurora">{c.titleHighlight}</span>{c.titleSuffix}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-paper/15 border border-paper/15">
          {LINKS.map((l) => (
            <a key={l.slug} href={l.href} target="_blank" rel="noreferrer" className="group bg-ink hover:bg-paper hover:text-ink transition-colors duration-300 p-8 flex items-center justify-between" data-testid={`contact-${l.slug}`}>
              <span className="font-display font-medium text-2xl">{l.label}</span>
              <ArrowUpRight size={22} className="group-hover:rotate-0 -rotate-45 transition-transform duration-300" />
            </a>
          ))}
        </div>

        <p className="mt-10 text-paper/50 font-light max-w-md">
          {c.calendlyNote}{" "}
          <a href={`mailto:${PROFILE.email}`} className="text-aurora">{PROFILE.email}</a>.
        </p>

        <div className="mt-20 pt-8 border-t border-paper/15 flex flex-wrap items-center justify-between gap-4 font-mono-tech text-[11px] uppercase tracking-[0.15em] text-paper/40">
          <span>&copy; {new Date().getFullYear()} {PROFILE.name} · {PROFILE.location}</span>
          <span className="flex items-center gap-4">
            <span>{c.footerTagline}</span>
            <Link to="/login" className="hover:text-paper transition-colors" data-testid="footer-admin-link">{c.adminLabel}</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
